export default __webpack_public_path__ + "static/media/screen_facebook_2.e62c1e9c.png";